// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2635":"2c308181","3759":"2c308181","4749":"2c308181"}[chunkId] + ".chunk.css";
};